import { render, staticRenderFns } from "./SnapshotTable.vue?vue&type=template&id=50348f2a&"
import script from "./SnapshotTable.vue?vue&type=script&lang=js&"
export * from "./SnapshotTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports